import React from 'react';
import { useTranslation } from 'react-i18next';
import { useBilingual } from '../hooks/useBilingual';
import './AboutPage.css';

const AboutPage = () => {
  const { t } = useTranslation();
  const { tb } = useBilingual();
  
  return (
    <div className="about-page">
      <div className="about-container">

        {/* 헤더 섹션 */}
        <div className="about-header">
          <h1 className="main-title">{tb('about.title')}</h1>
          <p className="description">
            {tb('about.description')}
          </p>
        </div>

        {/* 콘텐츠 섹션 */}
        <div className="about-content">
          <div className="content-grid">
            <div className="content-section">
              <h3><span className="check-icon">✓</span> {tb('about.evaluationStructure')}</h3>
              <p>
                {tb('about.evaluationDescription')}
              </p>
            </div>

            <div className="content-section">
              <h3><span className="check-icon">✓</span> {tb('about.keyFeatures')}</h3>
              <ul>
                <li>{tb('about.feature1')}</li>
                <li>{tb('about.feature2')}</li>
                <li>{tb('about.feature3')}</li>
                <li>{tb('about.feature4')}</li>
              </ul>
            </div>
          </div>

          <div className="content-section single">
            <h3><span className="check-icon">✓</span> {tb('about.targetUsers')}</h3>
            <ul>
              <li><strong>{tb('about.targetStudent')}</strong> {tb('about.targetStudentDesc')}</li>
              <li><strong>{tb('about.targetTeacher')}</strong> {tb('about.targetTeacherDesc')}</li>
              <li><strong>{tb('about.targetParent')}</strong> {tb('about.targetParentDesc')}</li>
              <li><strong>{tb('about.targetInstitution')}</strong> {tb('about.targetInstitutionDesc')}</li>
              <li><strong>{tb('about.targetGeneral')}</strong> {tb('about.targetGeneralDesc')}</li>
            </ul>
          </div>
        </div>

        {/* 하단 CTA 섹션 */}
        <div className="about-cta">
          <div className="cta-content">
            <p className="cta-text">
              {tb('about.ctaText1')}<br/>
              {tb('about.ctaText2')}<br/>
              {tb('about.ctaText3')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage; 